import { Layout } from "~landing/components/layout";
import { Security } from "~landing/components/security/security";

export function SecurityPolicy() {
	return (
		<Layout>
			<main>
				<Security />
			</main>
		</Layout>
	);
}
